module.exports = __webpack_public_path__ + "img/new.82b5f06b.svg";